import { PaintedScene } from '../PaintedScene';

export const CARAVANSERAI_PHASER_KEY = 'CaravanseraiScene' as const;
export const CARAVANSERAI_MANIFEST_KEY = 's-201-dune-edge-caravanserai' as const;

export class CaravanseraiScene extends PaintedScene {
  constructor() {
    super(CARAVANSERAI_PHASER_KEY, CARAVANSERAI_MANIFEST_KEY);
  }
}
